import React from 'react';
import PropTypes from 'prop-types';
import {Grid} from 'semantic-ui-react';

import Form from '@appComponents/ReduxFormControls';

const StageCategoryFormColumns = ({columns, stageCategoriesManager, staticData}) => (
    <>
        <Grid.Column width={columns.first_stage_category.width}>
            {stageCategoriesManager?.firstStageCategories ? (
                <Form.FormRow
                    component={Form.SemanticSelect}
                    defaultValue={stageCategoriesManager.firstStageCategoryValue}
                    onChangeSelect={stageCategoriesManager.handleFirstStageCategoryChange}
                    options={stageCategoriesManager.firstStageCategories}
                    name='first_stage_category'
                    placeholder='Select 1st stage category'
                    required
                />
            ) : (
                staticData?.first_stage_category?.name
            )}
        </Grid.Column>
        <Grid.Column width={columns.second_stage_category.width}>
            {stageCategoriesManager?.secondStageCategories ? (
                <Form.FormRow
                    component={Form.SemanticSelect}
                    disabled={!stageCategoriesManager.firstStageCategoryValue}
                    defaultValue={stageCategoriesManager.secondStageCategoryValue}
                    onChangeSelect={stageCategoriesManager.handleSecondStageCategoryChange}
                    loading={stageCategoriesManager.secondStageCategoriesLoading}
                    options={stageCategoriesManager.secondStageCategories}
                    name='second_stage_category'
                    placeholder='Select 2nd stage category'
                    required
                />
            ) : (
                staticData?.second_stage_category?.name
            )}
        </Grid.Column>
    </>
);

StageCategoryFormColumns.propTypes = {
    columns: PropTypes.object.isRequired,
    stageCategoriesManager: PropTypes.object.isRequired,
    staticData: PropTypes.object,
};

export default StageCategoryFormColumns;
